import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { faAddressCard, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ListItemIcon, Menu, MenuItem } from "@mui/material";
import Divider from "@mui/material/Divider";

interface NavMenuProps {
  id: string;
  anchorEl: HTMLElement | null;
  handleMenuClose: () => void;
  handleLogout: () => void;
}

const NavMenu = ({
  id,
  anchorEl,
  handleMenuClose,
  handleLogout,
}: NavMenuProps) => {
  return (
    <Menu
      anchorEl={anchorEl}
      id={id}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
    >
      <MenuItem
        component={RouterLink}
        to="/profile/edit"
        onClick={handleMenuClose}
      >
        <ListItemIcon>
          <FontAwesomeIcon icon={faAddressCard} fontSize="small" />
        </ListItemIcon>
        แก้ไขข้อมูลส่วนตัว
      </MenuItem>
      <Divider />
      <MenuItem onClick={handleLogout}>
        <ListItemIcon>
          <FontAwesomeIcon icon={faSignOutAlt} fontSize="small" />
        </ListItemIcon>
        ออกจากระบบ
      </MenuItem>
    </Menu>
  );
};

export default NavMenu;
